// extracted by mini-css-extract-plugin
export default {"bannerTxtContainer":"BannerComponent_bannerTxtContainer__dSujY"};